// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"f856696e","293":"03047730","298":"5b1a576d","372":"b778b9b5","472":"cf82bda6","615":"b93a1b32","650":"6be5b77a","735":"0444b141","750":"b98f3a02","937":"1ec0fca2"}[chunkId] + ".chunk.js";
};